<template>
  <div class="success-step">
    <div class="step-content">
      <h1 class="step-title">Community Created!</h1>
      <p class="step-subtitle">Your community is live.</p>

      <div class="description-section mt-8">
        <p class="description-text">
          Invite members to start conversations. Send invites by email, CSV,
          link or social share — or do it later from Settings → Members.
        </p>
      </div>
    </div>

    <div class="step-actions">
      <v-btn
        large
        rounded
        class="omit-btn"
        min-width="160"
        height="36"
        @click="omitInvites"
      >
        Omit for now
      </v-btn>

      <v-btn
        large
        rounded
        class="invite-btn"
        min-width="180"
        height="36"
        @click="openInviteModal"
      >
        <v-icon left size="18">fa-regular fa-user-plus</v-icon>
        Invite Now
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    communityId: {
      type: Number,
      required: true
    }
  },
  methods: {
    goBack() {
      this.$emit('close')
    },

    omitInvites() {
      // Show the AllSetModal instead of just closing
      this.$emit('show-all-set-modal')
    },

    openInviteModal() {
      this.$emit('open-invite-modal')
    }
  }
}
</script>

<style scoped lang="scss">
.success-step {
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.step-content {
  flex: 0 1 auto;
}

.step-title {
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 1.2;
  color: #14161B;
  margin-bottom: 12px;
}

.step-subtitle {
  font-size: 1rem;
  line-height: 1.5;
  color: #6B6B6B;
  margin-bottom: 0;
}

.description-section {
  margin-bottom: 0;
}

.description-text {
  font-size: 1rem;
  line-height: 1.6;
  color: #6B6B6B;
  margin-bottom: 0;
}

.step-actions {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 40px;
}

.v-btn.omit-btn {
  background-color: #EBEBEB !important;
  color: #14161B !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;

  &:hover {
    background-color: #D9D9D9 !important;
  }

  &:not(.v-btn--disabled) {
    background-color: #EBEBEB !important;
    color: #14161B !important;
  }
}

.v-btn.invite-btn {
  background-color: #28EA96 !important;
  color: #005931 !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;

  &:hover {
    background-color: #1fd985 !important;
  }
}

@media (max-width: 960px) {
  .step-title {
    font-size: 2rem;
  }

  .step-subtitle {
    font-size: 0.9rem;
  }

  .description-text {
    font-size: 0.9rem;
  }

  .step-actions {
    flex-direction: column;
  }
}
</style>
